<svg xmlns="http://www.w3.org/2000/svg" class="svg-img-externe" width="29.207" height="29.608" viewBox="0 0 29.207 29.608" attr.aria-label="{{ 'piv.lienExterne' | translate }}">
  <g id="Groupe_394" data-name="Groupe 394" transform="translate(-139 -545.624)">
    <g id="Groupe_390" data-name="Groupe 390" transform="translate(-1722.008 437.524)">
      <g id="Groupe_389" data-name="Groupe 389">
        <path id="Tracé_671" data-name="Tracé 671" d="M1884.087,120.814a1.145,1.145,0,0,0-1.145,1.145v13.458H1863.3v-20.1h13.057a1.146,1.146,0,1,0,0-2.291h-15.348v24.683h24.225V121.959A1.146,1.146,0,0,0,1884.087,120.814Z" fill="#095797"/>
        <path id="Tracé_672" data-name="Tracé 672" d="M1879.792,108.1a1.146,1.146,0,0,0,0,2.291h6.533l-14.019,14.17a1.146,1.146,0,0,0,1.629,1.611l13.989-14.14v6.377a1.146,1.146,0,0,0,2.291,0V108.1Z" fill="#095797"/>
      </g>
    </g>
  </g>
</svg>
